import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_f_info_circle_dark_blue.svg'
import _imports_1 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'
import _imports_2 from '@/app/ui/assets/svg/announce-fill.svg'


const _hoisted_1 = { class: "flex w-full flex-row gap-x-6" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "w-1/12 font-semibold text-12px xxl:text-14px text-center" }, " No ", -1)
const _hoisted_3 = { class: "w-40 font-semibold text-12px xxl:text-14px flex flex-row" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "font-normal text-gray-lp-500" }, " (kg)", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "text-red-lp-300 font-normal pl-1" }, "*", -1)
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = { class: "w-4/12 font-semibold text-12px xxl:text-14px" }
const _hoisted_8 = { class: "font-normal text-gray-lp-500" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "text-red-lp-300 font-normal pl-1" }, "*", -1)
const _hoisted_10 = { class: "w-36 font-semibold text-14p text-center" }
const _hoisted_11 = { class: "w-full" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "border-t mt-4" }, null, -1)
const _hoisted_13 = { class: "flex flex-row items-center gap-x-6" }
const _hoisted_14 = { class: "w-1/12 text-12px xxl:text-14px font-montserrat text-center" }
const _hoisted_15 = { class: "w-40" }
const _hoisted_16 = { class: "w-4/12" }
const _hoisted_17 = { class: "w-36 text-12px xxl:text-14px font-montserrat text-center" }
const _hoisted_18 = {
  key: 0,
  class: "w-20"
}
const _hoisted_19 = {
  key: 1,
  class: "w-50 p-1 bg-blue-lp-600 flex gap-x-1 rounded-md"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "info-blue"
}, null, -1)
const _hoisted_21 = { class: "text-10px text-blue-lp-500" }
const _hoisted_22 = {
  key: 0,
  class: "flex flex-row pl-5 pt-1"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "w-1/12" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4.5 max-w-none",
  alt: "exclamation tiangle red"
}, null, -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("p", { class: "text-red-lp-100 text-12px xxl:text-14px flex pl-1 gap-x-2" }, " Berat kotor wajib diisi. ", -1)
const _hoisted_26 = {
  key: 1,
  class: "flex flex-row pl-5 pt-1"
}
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "w-1/12" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4.5 max-w-none",
  alt: "exclamation tiangle red"
}, null, -1)
const _hoisted_29 = { class: "text-red-lp-100 text-12px xxl:text-14px flex pl-1 gap-x-2" }
const _hoisted_30 = {
  key: 2,
  class: "flex flex-row pl-5 pt-1"
}
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "w-1/12" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4.5 max-w-none",
  alt: "exclamation tiangle red"
}, null, -1)
const _hoisted_33 = { class: "text-red-lp-100 text-12px xxl:text-14px flex pl-1 gap-x-2" }
const _hoisted_34 = {
  key: 0,
  class: "flex flex-row justify-start gap-x-6"
}
const _hoisted_35 = /*#__PURE__*/_createVNode("div", { class: "w-1/12" }, null, -1)
const _hoisted_36 = { class: "flex flex-row px-4 py-2 rounded-lg mt-4 w-max bg-yellow-lp-400 items-center" }
const _hoisted_37 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "mr-2",
  alt: "announce",
  style: {"height":"24px","width":"24px"}
}, null, -1)
const _hoisted_38 = { class: "text-yellow-lp-500 text-14px" }
const _hoisted_39 = {
  key: 0,
  class: "flex flex-row justify-between text-12px xxl:text-14px px-6 my-6"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_InputDimension = _resolveComponent("InputDimension")!
  const _component_Icons = _resolveComponent("Icons")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Title, {
      class: "flex pb-6",
      label: _ctx.$t('revamp.booking.itemWeight'),
      fontSize: 20
    }, null, 8, ["label"]),
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.$t("bookingShipment.column.grossWeight")) + " ", 1),
        _hoisted_4,
        _hoisted_5,
        _createVNode("div", _hoisted_6, [
          _createVNode("img", {
            onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOpenTooltipWeight = true)),
            onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isOpenTooltipWeight = false)),
            src: 
                _ctx.isOpenTooltipWeight
                  ? require('@/app/ui/assets/svg/info-red.svg')
                  : require('@/app/ui/assets/svg/info.svg')
              ,
            alt: "",
            class: "ml-2"
          }, null, 40, ["src"]),
          _withDirectives(_createVNode(_component_Tooltip, {
            title: _ctx.$t('bookingShipment.tooltip.weight'),
            message: _ctx.$t('bookingShipment.tooltip.weightMsg'),
            footer: "",
            style: {"width":"280px","margin-left":"2.6em","margin-top":"-2.6em"}
          }, null, 8, ["title", "message"]), [
            [_vShow, _ctx.isOpenTooltipWeight]
          ])
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _createTextVNode(_toDisplayString(_ctx.$t("bookingShipment.column.dimensionsPackage")) + " ", 1),
        _createVNode("span", _hoisted_8, " (" + _toDisplayString(_ctx.$t("bookingShipment.placeholder.dimensionsPackage")) + ")", 1),
        _hoisted_9
      ]),
      _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("bookingShipment.column.dimensionWeight")), 1)
    ]),
    _createVNode("div", _hoisted_11, [
      _hoisted_12,
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listKGs, (key, index) => {
        return (_openBlock(), _createBlock("div", {
          key: index,
          class: "flex flex-col py-6 border-b"
        }, [
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, _toDisplayString(index + 1), 1),
            _createVNode("div", _hoisted_15, [
              _createVNode(_component_lp_input, {
                modelValue: key.grossWeight,
                "onUpdate:modelValue": [($event: any) => (key.grossWeight = $event), ($event: any) => (_ctx.setOnValidationHws(key.grossWeight, index))],
                format: _ctx.formatFloat,
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('onUpdateEmbargoStatusFail'))),
                placeholder: "e.g 20",
                maxLength: _ctx.isMaxLengthGrossWeight,
                error: _ctx.errorEmbargo.weightStatus,
                onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('setFieldIndex', 22)))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "format", "maxLength", "error"])
            ]),
            _createVNode("div", _hoisted_16, [
              _createVNode(_component_InputDimension, {
                length: key.dimension.length,
                "onUpdate:length": ($event: any) => (key.dimension.length = $event),
                width: key.dimension.width,
                "onUpdate:width": ($event: any) => (key.dimension.width = $event),
                height: key.dimension.height,
                "onUpdate:height": ($event: any) => (key.dimension.height = $event),
                onInput: ($event: any) => (_ctx.calculationVolumeWeight(index)),
                error: _ctx.errorEmbargo.lengthStatus,
                onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('onUpdateEmbargoStatusFail')))
              }, null, 8, ["length", "onUpdate:length", "width", "onUpdate:width", "height", "onUpdate:height", "onInput", "error"])
            ]),
            _createVNode("div", _hoisted_17, _toDisplayString(key.convertVolumeWeight) + " kg ", 1),
            (_ctx.listKGs.length > 1)
              ? (_openBlock(), _createBlock("div", _hoisted_18, [
                  _withDirectives(_createVNode("div", {
                    onClick: ($event: any) => (_ctx.removeKGs(index)),
                    class: "self-center cursor-pointer ml-3 relative"
                  }, [
                    _createVNode("div", {
                      class: "img-close-icon",
                      onMouseenter: ($event: any) => (_ctx.isHoverEnter(index)),
                      onMouseleave: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isHoverDelete = false))
                    }, [
                      _withDirectives(_createVNode(_component_Tooltip, {
                        message: "Hapus Barang",
                        title: "",
                        footer: "",
                        style: {"width":"135px","margin-left":"1.5em","margin-top":"-1.3em"}
                      }, null, 512), [
                        [_vShow, _ctx.isHoverDelete && index === _ctx.cacheIndex]
                      ])
                    ], 40, ["onMouseenter"])
                  ], 8, ["onClick"]), [
                    [_vShow, _ctx.listKGs.length > 1]
                  ])
                ]))
              : _createCommentVNode("", true),
            (index === 0)
              ? (_openBlock(), _createBlock("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode("p", _hoisted_21, _toDisplayString(_ctx.$t("bookingV3.shipment.weightPieces.infobarWeightComma")), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          (key.grossWeight === null || key.grossWeight === '')
            ? (_openBlock(), _createBlock("div", _hoisted_22, [
                _hoisted_23,
                _hoisted_24,
                _hoisted_25
              ]))
            : _createCommentVNode("", true),
          (key.errorHws)
            ? (_openBlock(), _createBlock("div", _hoisted_26, [
                _hoisted_27,
                _hoisted_28,
                _createVNode("p", _hoisted_29, " Berat mulai " + _toDisplayString(_ctx.configHeavyWeightMinimum.heavyWeightMinimum) + " kg hanya 1 koli. Ubah berat atau booking baru. ", 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.validateTotalGrossWeight)
            ? (_openBlock(), _createBlock("div", _hoisted_30, [
                _hoisted_31,
                _hoisted_32,
                _createVNode("p", _hoisted_33, _toDisplayString(_ctx.$t("bookingShipment.error.exceedMaxWeightCheck")), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isGrossWeight && _ctx.isCampaign)
            ? (_openBlock(), _createBlock("div", {
                key: 3,
                class: 
            `flex flex-row justify-between text-12px xxl:text-14px ${
              _ctx.isGrossWeight && _ctx.isCampaign
                ? 'text-gray-lp-300 font-semibold'
                : 'text-gray-lp-600 font-normal'
            }`
          
              }, null, 2))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      (_ctx.showWarningHws)
        ? (_openBlock(), _createBlock("div", _hoisted_34, [
            _hoisted_35,
            _createVNode("div", _hoisted_36, [
              _hoisted_37,
              _createVNode("p", _hoisted_38, " Berat diatas " + _toDisplayString(_ctx.configHeavyWeightMinimum.heavyWeightMinimum) + " kg akan dikenakan biaya tambahan & Anda tidak dapat menambah koli lagi. ", 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isMaxAddKgs && _ctx.accountIsNonForeign)
      ? (_openBlock(), _createBlock("div", _hoisted_39, [
          (
          !_ctx.isVendorNinjaDestination &&
            !_ctx.allowToAddMoreKoli &&
            !_ctx.allowToAddMoreKoliVolume
        )
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                onClick: _cache[7] || (_cache[7] = ($event: any) => (
          _ctx.modelValue.productName === 'INTERPACK' ||
          _ctx.showWarningHws ||
          _ctx.isErrorHws
            ? null
            : _ctx.addKGs()
        )),
                class: 
          `flex gap-3 ${
            _ctx.modelValue.productName === 'INTERPACK' ||
            _ctx.showWarningHws ||
            _ctx.isErrorHws
              ? 'text-gray-lp-600 cursor-not-allowed'
              : 'text-red-lp-300 cursor-pointer'
          }`
        
              }, [
                _createVNode(_component_Icons, {
                  name: "plus-circle",
                  class: 
            `${
              _ctx.modelValue.productName === 'INTERPACK' ||
              _ctx.showWarningHws ||
              _ctx.isErrorHws
                ? 'text-gray-lp-600'
                : 'text-red-lp-300'
            }`
          
                }, null, 8, ["class"]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("bookingShipment.action.addItems")), 1)
              ], 2))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}